import {
  Box,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import useLang from "../../../../Shared/hooks/useLanguage";
import {
  AddIcon,
  CrossIcon,
  DoneIcon,
  RemoveICon,
} from "../../../../Shared/Icons";
import TestList from "./TestList";
import { PanelSetupSaveData } from "Services/NGSCompendium";
import PermissionComponent from "Shared/Common/Permissions/PermissionComponent";
import { reactSelectSMStyle, styles } from "Utils/Common";
import { validateFields } from "Pages/LIS/Toxicology/CommonFunctions";

function Row({
  row,
  rows,
  index,
  setRows,
  loadData,
  dropDownValues,
  queryDisplayTagNames,
  setIsAddButtonDisabled,
}: any) {
  const { t } = useLang();
  const [anchorEl, setAnchorEl] = React.useState({
    dropdown1: null,
    dropdown2: null,
    dropdown3: null,
    dropdown4: null,
  });

  const handleClose = (dropdownName: string) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: null });
  };

  const [disableSaveBbutton, setDisableSaveBbutton] = useState(false);
  const [isExpand, setIsExpand] = useState<boolean>(false);

  const showExpand = () => {
    setIsExpand(!isExpand);
  };

  const getValues = (r: any) => {
    const updatedRows = rows.map((row: any) => {
      if (row.id === r.id) {
        return { ...row, rowStatus: true };
      }
      return row;
    });
    setRows(updatedRows);
  };

  const handleChange = (name: string, value: string, id: number) => {
    setRows((curr: any) =>
      curr.map((x: any) =>
        x.id === id
          ? {
              ...x,
              [name]: value,
            }
          : x
      )
    );
  };

  const handlesave = async () => {
    const { isValid, invalidField } = validateFields({
      panelName: row.panelName,
      groupId: row.groupId,
    });

    if (!isValid) {
      const errorMessage = invalidField
        ? `Please Fill ${queryDisplayTagNames[invalidField] ?? ""} field`
        : "Invalid field found";
      toast.error(errorMessage);
      return;
    }

    const payload = {
      id: row.id,
      panelName: row.panelName,
      panelAbbreviation: row.panelAbbreviation ?? "",
      groupId: row.groupId,
      groupName: row.groupName,
      sortOrder: row.sortOrder,
    };

    try {
      setDisableSaveBbutton(true);

      const res = await PanelSetupSaveData(payload);

      if (res?.data?.httpStatusCode === 200) {
        loadData();
        setIsAddButtonDisabled(false);
        handleClose("dropdown2");
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Save failed:", error);
      toast.error("An unexpected error occurred.");
    } finally {
      setDisableSaveBbutton(false);
    }
  };

  return (
    <>
      <TableRow className="h-30px">
        <TableCell>
          {row.rowStatus ? null : (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={showExpand}
              className="btn btn-icon btn-icon-light btn-sm fw-bold btn-table-expend-row rounded h-20px w-20px"
            >
              {isExpand ? (
                <button
                  id={`NGSCompendiumDataPanelSetupExpandClose_${row.id}`}
                  className="btn btn-icon btn-icon-light btn-sm fw-bold btn-table-expend-row rounded h-20px w-20px min-h-20px"
                >
                  <RemoveICon />
                </button>
              ) : (
                <button
                  id={`NGSCompendiumDataPanelSetupExpandOpen_${row.id}`}
                  className="btn btn-icon btn-icon-light btn-sm fw-bold btn-primary rounded h-20px w-20px min-h-20px"
                >
                  <AddIcon />
                </button>
              )}
            </IconButton>
          )}
        </TableCell>
        <TableCell>
          <div className="d-flex justify-content-center">
            {row?.rowStatus ? (
              <div className="gap-2 d-flex">
                <button
                  disabled={disableSaveBbutton}
                  id={`NGSCompendiumSave`}
                  onClick={() => {
                    handlesave();
                  }}
                  className="btn btn-icon btn-sm fw-bold btn-table-save btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <DoneIcon />
                </button>
                <button
                  id={`NGSCompendiumCancel`}
                  onClick={() => {
                    loadData();
                    handleClose("dropdown2");
                    if (row?.id !== 0) {
                      const updatedRows = rows.map((r: any) => {
                        if (r.id === row?.id) {
                          return { ...r, rowStatus: false };
                        }
                        return r;
                      });
                      setRows(updatedRows);
                    } else {
                      const newArray = [...rows];
                      newArray.splice(index, 1);
                      setRows(newArray);
                      setIsAddButtonDisabled(true);
                    }
                  }}
                  className="btn btn-icon btn-sm fw-bold btn-table-cancel btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <CrossIcon />
                </button>
              </div>
            ) : (
              <div className="rotatebtnn">
                <DropdownButton
                  className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
                  key="end"
                  id={`NGSCompendium3Dots_${row.id}`}
                  drop="end"
                  title={<i className="bi bi-three-dots-vertical p-0"></i>}
                >
                  <PermissionComponent
                    moduleName="NGS LIS"
                    pageName="Compendium Data"
                    permissionIdentifier="Edit"
                  >
                    <Dropdown.Item
                      id={`NGSCompendiumEdit`}
                      className="w-auto"
                      eventKey="2"
                      onClick={() => {
                        getValues(row);
                      }}
                    >
                      <i className={"fa fa-edit text-primary mr-2"}></i>
                      {t("Edit")}
                    </Dropdown.Item>
                  </PermissionComponent>
                </DropdownButton>
              </div>
            )}
          </div>
        </TableCell>
        <TableCell
          id={`NGSCompendiumPanelName_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <input
                id={`NGSCompendiumpanelName`}
                type="text"
                placeholder={t("Panel Name")}
                name="panelName"
                className="form-control bg-white mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.panelName}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.id)
                }
              />
            </div>
          ) : (
            row?.panelName
          )}
        </TableCell>
        <TableCell
          id={`NGSCompendiumPanelAbbreviation_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="d-flex">
              <input
                id={`NGSCompendiumpanelAbbreviation`}
                type="text"
                placeholder={t("Panel Abbreviation")}
                name="panelAbbreviation"
                className="form-control bg-white mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.panelAbbreviation ?? ""}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.id)
                }
              />
            </div>
          ) : (
            row?.panelAbbreviation
          )}
        </TableCell>
        <TableCell
          id={`NGSCompendiumGroup_${row.id}`}
          sx={{ width: "max-content" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <div className="w-100">
                <Select
                  inputId="NGSPanelMapping_groupId"
                  menuPortalTarget={document.body}
                  options={dropDownValues}
                  styles={reactSelectSMStyle}
                  theme={(theme) => styles(theme)}
                  placeholder={t("Group Name")}
                  name="groupId"
                  value={dropDownValues?.filter(
                    (item: any) => item?.value === row?.groupId
                  )}
                  onChange={(event: any) => {
                    handleChange("groupId", event.value, row.id);
                  }}
                />
              </div>
            </div>
          ) : (
            row?.groupName
          )}
        </TableCell>
        <TableCell
          id={`NGSCompendiumSequence_${row.id}`}
          sx={{ width: "max-content" }}
        >
          {row?.rowStatus ? (
            <div className="d-flex">
              <input
                id={`NGSCompendiumSequence`}
                type="number"
                name="sortOrder"
                className="form-control bg-white mb-3 mb-lg-0 h-33px rounded-2 fs-8 w-100"
                placeholder={t("Sort Order")}
                value={row.sortOrder || ""}
                onChange={(e: any) => {
                  handleChange("sortOrder", e.target.value, row.id);
                }}
                min="1"
              />
            </div>
          ) : (
            row?.sortOrder
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={9} className="padding-0">
          <Collapse in={isExpand} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography gutterBottom component="div">
                <div className="table-expend-sticky">
                  <div className="row">
                    <div className="col-lg-12 bg-white px-lg-14 px-md-10 px-4 pb-6">
                      <TestList
                        row={row}
                        setIsExpand={setIsExpand}
                        getPanelData={loadData}
                      />
                    </div>
                  </div>
                </div>
              </Typography>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
